import React from 'react';
import { Target, Eye, Users, Award } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

export const About = () => {
  const values = [
    { icon: Target, title: 'Neutral & Open', description: 'No lock-in, no middleman fees. We integrate, not compete with operators' },
    { icon: Users, title: 'Inclusive by Design', description: 'Multi-language, voice assistance, and low-bandwidth access for all Indians' },
    { icon: Award, title: 'Data-Driven', description: 'Real-time intelligence and predictive insights for better mobility decisions' },
    { icon: Eye, title: 'Transparent', description: 'Open APIs, clear pricing and privacy-first data handling' }
  ];

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-[#1B4F72] to-[#138808] text-white py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-5xl font-bold mb-6">About Mahasarathi</h1>
          <p className="text-xl text-gray-100 max-w-3xl mx-auto leading-relaxed">
            Building India's unified mobility layer - a neutral, interoperable platform connecting fragmented transport systems into one seamless ecosystem
          </p>
        </div>
      </section>

      {/* Our Story */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl font-bold text-[#1B4F72] mb-8 text-center">The UPI for Mobility</h2>
          <div className="space-y-6 text-gray-700 leading-relaxed text-lg">
            <p>
              Just as UPI revolutionized digital payments in India by creating an interoperable layer connecting banks, 
              Mahasarathi is building the unified mobility layer that connects buses, metros, trains, cabs and future 
              transport modes into one real-time, coordinated system.
            </p>
            <p>
              Today, 85% of urban commuters are dissatisfied with their daily travel experience. India loses ₹22B+ 
              annually to traffic congestion and commuters juggle 5+ different apps for a single journey. The problem 
              isn't lack of transport options - it's the lack of integration.
            </p>
            <p>
              Mahasarathi is the solution: a neutral platform that doesn't compete with operators, but empowers them. 
              We provide the digital infrastructure that makes multi-modal mobility work seamlessly - from live ETAs 
              and route planning to unified payments and real-time coordination.
            </p>
            <p>
              Aligned with India's National Urban Mobility Mission and built on the proven DPI model (like UPI, Aadhaar, 
              and ONDC), we're creating the mobility layer that India deserves - open, neutral and built for scale.
            </p>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12">
            <Card className="border-0 shadow-lg">
              <CardContent className="p-10">
                <div className="w-16 h-16 bg-gradient-to-br from-[#FF9933] to-[#E68A2E] rounded-xl flex items-center justify-center mb-6">
                  <Target className="text-white" size={32} />
                </div>
                <h3 className="text-3xl font-bold text-[#1B4F72] mb-4">Our Mission</h3>
                <p className="text-gray-700 leading-relaxed text-lg">
                  To create India's unified mobility layer - a neutral, interoperable platform that connects all 
                  transport modes into one seamless ecosystem, making multi-modal travel as simple as digital payments.
                </p>
              </CardContent>
            </Card>

            <Card className="border-0 shadow-lg">
              <CardContent className="p-10">
                <div className="w-16 h-16 bg-gradient-to-br from-[#138808] to-[#0F6806] rounded-xl flex items-center justify-center mb-6">
                  <Eye className="text-white" size={32} />
                </div>
                <h3 className="text-3xl font-bold text-[#1B4F72] mb-4">Our Vision</h3>
                <p className="text-gray-700 leading-relaxed text-lg">
                  To become the foundational digital infrastructure for mobility in India - powering seamless, 
                  sustainable and equitable transport for millions while enabling cities to grow smarter and greener.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-bold text-[#1B4F72] mb-16 text-center">Our Core Values</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => {
              const Icon = value.icon;
              return (
                <div key={index} className="text-center">
                  <div className="w-20 h-20 bg-gradient-to-br from-[#1B4F72] to-[#2E86AB] rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
                    <Icon className="text-white" size={32} />
                  </div>
                  <h3 className="text-xl font-bold text-[#1B4F72] mb-3">{value.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{value.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Stats */}
      {/* <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-r from-[#1B4F72] to-[#138808] text-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-4 gap-8 text-center">
            <div>
              <p className="text-5xl font-bold mb-2">50K+</p>
              <p className="text-gray-200">Active Users</p>
            </div>
            <div>
              <p className="text-5xl font-bold mb-2">8+</p>
              <p className="text-gray-200">Partner Integrations</p>
            </div>
            <div>
              <p className="text-5xl font-bold mb-2">100K+</p>
              <p className="text-gray-200">Journeys Completed</p>
            </div>
            <div>
              <p className="text-5xl font-bold mb-2">4.8/5</p>
              <p className="text-gray-200">User Satisfaction</p>
            </div>
          </div>
        </div>
      </section> */}
    </div>
  );
};
